export const determineAPIUrl = (): string => {
  const hostname = window.location.hostname;

  // Production: [custom].portal.verifyiq.xyz → [custom].portal.backend.boost-capital.app
  const verifyiqPattern = /^(.+)\.portal\.verifyiq\.xyz$/;
  const verifyiqMatch = hostname.match(verifyiqPattern);

  if (verifyiqMatch && verifyiqMatch[1]) {
    return `https://${verifyiqMatch[1]}.portal.backend.boost-capital.app`;
  }

  // Legacy/staging: [subdomain].boost-frontend.app → [subdomain].backend.boost-capital.app
  const frontendPattern = /^(.+)\.boost-frontend\.app$/;
  const match = hostname.match(frontendPattern);

  if (match && match[1]) {
    const subdomain = match[1];
    return `https://${subdomain}.backend.boost-capital.app`;
  }

  // Fallback for localhost or other development environments
  return process.env.REACT_APP_API_URL || 'http://localhost:4000';
};
